export function clamp(t,[n,r]){return Math.min(r,Math.max(n,t))}export function wrap(t,n){return(n+t)%n}
//# sourceMappingURL=index.module.js.map
